// extracted by mini-css-extract-plugin
export var btnClaim = "ButtonClaim_btnClaim__NqGys";
export var iconWrap = "ButtonClaim_iconWrap__yonS0";
export var rotate = "ButtonClaim_rotate__LA+hy";
export var dotty = "ButtonClaim_dotty__ZqwuI";